import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showResult'
})
export class ShowResultPipe implements PipeTransform {

  transform(list: any[]): any[] {
    return list.filter(item => item.show_flg == true);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pipes/show-result.pipe.ts